module.exports = __webpack_public_path__ + "static/media/3.aa3cf9a8.jpg";